import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditorContent = _resolveComponent("EditorContent")!

  return (_openBlock(), _createElementBlock("div", {
    class: "custom-editor-input",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTriggerFocus && _ctx.onTriggerFocus(...args)))
  }, [
    _createVNode(_component_EditorContent, {
      id: _ctx.id,
      editor: _ctx.editor,
      class: _normalizeClass(["custom-editor-input__in", { 'is-error': _ctx.isError }])
    }, null, 8, ["id", "editor", "class"]),
    _renderSlot(_ctx.$slots, "footer", { editor: _ctx.editor })
  ]))
}